import { Patient } from "@domain/patient";

export const PATIENT_CREATE_EVENT = 'patients:open-create';
export const PATIENT_CREATE_SESSION_KEY = 'patients:open-create';
export const PATIENT_CREATED_EVENT = 'patients:created';

export type PatientCreatedEventDetail = {
  patient: Patient
  temporaryPassword: string;
};
